import React, { Component } from "react";
import NumberFormat from "react-number-format";
import InputMask from "./popup/InputMask";
import TimeDD from "./popup/TimeDD";

class SimpleInput extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { label, mandatory, readOnly, box, type, value } = this.props
        return (
            <div className="margin-bottom-20px">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                </div>
                {box === 'number' ?
                    <NumberFormat
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type="text"
                        className="txt txt-sekunder-color"
                    // placeholder=""
                    /> :
                    box === 'mask' ?
                        <InputMask
                            {...this.props}
                        /> :
                        box === 'time' ?
                            <TimeDD {...this.props} /> :
                            <input
                                {...this.props}
                                style={{ backgroundColor: readOnly && "#E6E6E6" }}
                                type={type ? type : "text"}
                                className="txt txt-sekunder-color"
                                value={value ?? ""}
                            />}
            </div>
        )
    }
}

export default SimpleInput